import classNames from 'classnames';
import type { CSSProperties } from 'react';
import React, { useEffect, useRef, useState } from 'react';
import * as styles from './RowColumnRearrangeDropIndicator.module.scss';

interface RowColumnRearrangeDropIndicatorProps {
  direction: 'row' | 'column';
  target: 'leading' | 'trailing';
}

const RowColumnRearrangeDropIndicator = ({
  direction,
  target,
}: RowColumnRearrangeDropIndicatorProps) => {
  const [style, setStyle] = useState<CSSProperties>({});
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const table = ref.current?.closest('table');
    if (table) {
      const tableRect = table.getBoundingClientRect();
      const property = direction === 'row' ? 'width' : 'height';
      setStyle({ [property]: tableRect[property] });
    }
  }, [direction]);

  return (
    <div
      ref={ref}
      style={style}
      className={classNames(
        styles.container,
        styles[direction],
        styles[target],
      )}
    />
  );
};

export default RowColumnRearrangeDropIndicator;
